"use client";

import "./page.scss";
import { useParams } from "next/navigation";
import IndustryPage from "@/dynamicPages/Industry";
import SubIndustryPage from "@/dynamicPages/SubIndustry";
import ArticlePage from "@/dynamicPages/Article/page";
import TopicPage from "@/dynamicPages/Topic";
import SubTopicPage from "@/dynamicPages/SubTopic";
import Sidebar from "@/elements/Sidebar";
import BreadCrumb from "@/reusablecomponents/BreadCrumb";
import FreeCoursesSection from "@/components/freecourses/FreeCoursesSection";
import QuestionsSection from "@/components/freecourses/QuestionsSection";
import NotFound from "@/app/not-found";
import { getSlugAndRouteName } from "@/utils/Functions";
import CourseDetail from "@/dynamicPages/Coursedetail/page";
const WrapperPage = ({
  data,
  subIndustriesData,
  thumbnails,
  testimonials,
  allCourses,
  freeCourseData,
  nextSchedule,
  topicIndustryData,
  industryData,
  mainIndustryData,
  indusData,
  currentIndustry,
  currentSubIndustry,
  industryFaqs,
  subIndustryFaqs,
  topicData,
  relatedCourseData,
  filteredSubIndustries,
  highlightedCourse,
  temp
}: any) => {
  const params = useParams();
  const {
    isIndustry,
    isSubIndustry,
    isSingleCourse,
    isArticle,
    isTopic,
    isSubTopic,
    routeId
  } = getSlugAndRouteName(params?.route?.toString() ?? "");
  if (isIndustry) return <div className="free_courses_container">
        <div className="max_container">
          <Sidebar data={data} subIndustriesData={subIndustriesData} />
          <div className="free_container">
            <BreadCrumb currentIndustry={currentIndustry} />
            <IndustryPage industryData={mainIndustryData} industryName={currentIndustry?.industryName} faqs={industryFaqs} filteredSubIndustries={filteredSubIndustries} />
            <FreeCoursesSection data={data} subIndustriesData={subIndustriesData} />
          </div>
        </div>
      </div>;
  if (isSubIndustry && indusData && mainIndustryData?.data?.length > 0 && industryData) return <div className="free_courses_container">
        <div className="max_container">
          <Sidebar data={data} subIndustriesData={subIndustriesData} />
          <div className="free_container">
            <BreadCrumb currentSubIndustry={currentSubIndustry} currentIndustry={currentIndustry} />
            <SubIndustryPage industryData={industryData} mainIndustryData={mainIndustryData} indusData={indusData} filteredSubIndustries={filteredSubIndustries} testimonials={testimonials} currentSubIndustry={currentSubIndustry?.industryName} faqs={subIndustryFaqs} />
            <FreeCoursesSection data={data} subIndustriesData={subIndustriesData} />
          </div>
        </div>
      </div>;
  if (isSingleCourse && freeCourseData && nextSchedule) return <CourseDetail thumbnails={thumbnails} testimonials={testimonials} allCourses={allCourses} industries={data} subIndustriesData={subIndustriesData} routeId={routeId} data={freeCourseData} relatedCourseData={relatedCourseData} NextSchedule={nextSchedule} filteredSubIndustries={filteredSubIndustries} />;
  if (isArticle) {
    return <div className="topic_container">
        <div className="topic_flex">
          <div className="container_wrapper">
            <BreadCrumb />
            <ArticlePage temp={temp} coursesData={allCourses} topicData={topicData} highlightedCourse={highlightedCourse} nextSchedule={nextSchedule} topicIndustryData={topicIndustryData} filteredSubIndustries={filteredSubIndustries} />
            <QuestionsSection />
            <FreeCoursesSection data={data} subIndustriesData={subIndustriesData} />
          </div>
        </div>
      </div>;
  }
  if (isTopic) return <div className="topic_container">
        <div className="topic_flex">
          <div className="container_wrapper">
            <BreadCrumb />{" "}
            <TopicPage topicData={topicData} topicIndustryData={topicIndustryData} filteredSubIndustries={filteredSubIndustries} />
            <QuestionsSection />
            <FreeCoursesSection data={data} subIndustriesData={subIndustriesData} />
          </div>
        </div>
      </div>;
  if (isSubTopic) {
    const topicName = topicData?.data[0].attributes.topicName;
    return <div className="topic_container">
        <div className="topic_flex">
          <div className="container_wrapper">
            <BreadCrumb topicName={topicName} />
            <SubTopicPage temp={temp} coursesData={allCourses} topicData={topicData} topicIndustryData={topicIndustryData} filteredSubIndustries={filteredSubIndustries} />
            <QuestionsSection />
            <FreeCoursesSection data={data} subIndustriesData={subIndustriesData} />
          </div>
        </div>
      </div>;
  }
  return <NotFound data-sentry-element="NotFound" data-sentry-component="WrapperPage" data-sentry-source-file="index.tsx" />;
};
export default WrapperPage;